import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../shared/services/app.service';
import { RequestService } from '../../shared/services/request.service';
import { Request } from "../../shared/models/request.model";
@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  private sub: any;
  public request : Request = new Request();


  constructor(private router: Router, private appService: AppService, private activatedRoute: ActivatedRoute, public requestService: RequestService) { }

  ngOnInit(): void {
    this.appService.setProgress("100");
    
    this.sub = this.activatedRoute.params.subscribe((params) => {
      this.requestService.getRequestStatusById(params["requestId"]).subscribe(data => {
        
        this.request = data
      })
    })
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

}
